import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si recién empiezo a dar clases o soy docente novel?',
    a: 'El MegaPack está diseñado para funcionar en cualquier etapa de la carrera docente. El Tomo 1 explica desde cero cómo construir una observación pedagógica profesional, sin asumir ningún conocimiento previo sobre redacción técnica. Muchos de nuestros compradores son docentes en sus primeros años que nunca tuvieron un modelo de informe claro. El sistema los llevó del "no sé cómo empezar" al "terminé el boletín en minutos" paso a paso.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de confirmar el pago recibís un correo con el enlace de descarga. El acceso es de por vida: podés descargar los archivos en tu celular, tablet o computadora y usarlos offline cuando quieras.'
  }, {
    q: '¿Funciona para todos los niveles educativos?',
    a: 'Sí. El MegaPack tiene tomos específicos para Nivel Inicial (Sala 3, 4 y 5), Nivel Primario (1° a 6° grado) y Nivel Secundario (1° a 6° año). También tiene contenido transversal aplicable a cualquier nivel como el Libro de Actas, los Bonus y el Diccionario de Sinónimos.'
  }, {
    q: '¿Las frases son genéricas o realmente se adaptan a cada alumno?',
    a: 'Las observaciones están organizadas por nivel de desempeño, área curricular y situación específica, lo que te permite elegir la frase que más se ajusta a cada alumno y editarla en segundos. El Diccionario de Sinónimos del Bonus 3 te da además 800+ alternativas para que nunca repitas la misma expresión dos veces.'
  }, {
    q: '¿El Planificador Sistémico es necesario o con el MegaPack base alcanza?',
    a: 'El MegaPack base te da todas las frases, modelos y plantillas para escribir informes profesionales ahora mismo. El Planificador Sistémico agrega el sistema de registro diario que genera los datos para que esos informes reflejen el proceso real de cada alumno a lo largo del año. Si querés resolver el cierre de este período, el MegaPack base es suficiente. Si querés transformar tu gestión docente completa, el combo con el Planificador es la opción más completa.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si el producto no cumple tus expectativas, te devolvemos el 100% del dinero. Sin formularios, sin demoras, sin drama.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-black" data-id="element-76">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-78">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="border border-violet-900/40 rounded-2xl overflow-hidden bg-zinc-900/60" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 hover:bg-zinc-900/40 transition-colors" aria-expanded={openIndex === i} data-id="element-81">
                <span className="font-bold text-white pr-4" data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-violet-300 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="px-6 pb-5 text-zinc-200 leading-relaxed border-t border-violet-900/30 pt-3" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}